export default __webpack_public_path__ + "static/media/VisionAI.33c46d45.png";